import { FC, ReactNode, ChangeEvent } from 'react';

interface TextFieldProps {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    labelSpan?: number;
    inputSpan?: number;
    buttonSpan?: number;
    type?: string;
    rightElement?: ReactNode;
    disabled?: boolean
}

const TextField: FC<TextFieldProps> = ({
    label = 'Label',
    placeholder = '',
    value = '',
    onChange = () => {},
    labelSpan = 2,
    inputSpan = 6,
    buttonSpan = 1,
    type = 'text',
    rightElement = null,
    disabled = false
}) => {
    const computedInputSpan = rightElement ? inputSpan - buttonSpan : inputSpan;

    return (
        <div className="form-group grid grid-cols-8 items-center gap-2">
            <label
                className={`form-label inline-block py-1.5 text-gray-700 font-medium col-span-${labelSpan}`}
            >
                {label}
            </label>

            <input
                type={type}
                className={`
                    form-control
                    col-span-${computedInputSpan}
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    transition
                    ease-in-out
                    m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                `}
                placeholder={placeholder}
                onChange={onChange}
                defaultValue={value}
                disabled={disabled}
            />

            {rightElement && (
                <div className={`col-span-${buttonSpan}`}>
                    {rightElement}
                </div>
            )}
        </div>
    );
};

export default TextField;
